import { store, authActions } from "../_store";
import { history } from "./history";
import { getStoredValue } from "../_helpers/storageHelper";

export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

const getBrowserType = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
    return "Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return "Safari";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    return "Opera";
  } else if (userAgent.includes("Trident")) {
    return "Internet Explorer";
  } else if (userAgent.includes("Edg")) {
    return "Edge";
  }
  else if (userAgent.indexOf("Edg/") > -1) {
    return "Edge";
  } else if (
    userAgent.indexOf("OPR/") > -1 ||
    userAgent.indexOf("Opera") > -1
  ) {
    return "Opera";
  } else if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } else if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (
    userAgent.indexOf("Trident") > -1 ||
    userAgent.indexOf("MSIE") > -1
  ) {
    return "Internet Explorer";
  } else {
    return "Unknown";
  }
};

function parseStack(stack) {
  if (!stack) return { fileName: 'Unknown', lineNumber: 'Unknown' };

  const stackLines = stack.split('\n');
  for (let line of stackLines) {
    const match = line.match(/(?:\()?(.*):(\d+):\d+\)?$/);
    if (match) {
      return {
        fileName: match[1].split('/').pop(), // just file name
        lineNumber: match[2],
      };
    }
  }

  return { fileName: 'Unknown', lineNumber: 'Unknown' };
}

function request(method) {
  return async (url, body, { isFile } = {}) => {
    const headers = {
      ...authHeader(url),
      'X-Client-IP': getStoredValue("cachedIP"),
      'X-Client-Browser': getBrowserType(),
      'X-Client-URL': window.location.href,
    };
    const requestOptions = {
      method,
      headers,
    };
    if (body) {
      requestOptions.body = JSON.stringify(body);
      requestOptions.headers["Content-Type"] = "application/json";
    }
    return await fetch(url, requestOptions).then(async (response) => {
      if (isFile) {
        if (!response.ok) {
          throw new Error("Failed to fetch file");
        }
        const reader = response.body.getReader();
        const chunks = [];
        let done, value;

        while (!done) {
          ({ done, value } = await reader.read());
          chunks.push(value);
        }
        const blob = new Blob(chunks);
        return blob;
      } else {
        return response.json();
      }
    }).catch(async (error) => {
      handleErrorlog(error, method, url, body);
      // Re-throw the error after logging
      throw error;
    });
  };
}

async function handleErrorlog(error, method, url, body) {
  // Prepare error log data
  try {
    const { fileName, lineNumber } = parseStack(error?.stack);
    const methodInfo = method || 'N/A';
    const requestBody = body ? JSON.stringify(body) : 'No body';

    const requestContext = `Method: ${methodInfo}, URL: ${url}, Body: ${requestBody}`;
    const storedLoginDetails = getStoredValue("loginDetails");
    const errorLog = {
      Message: `${error?.message}  | Time: ${new Date().toISOString()}`,
      StackTrace: `${error?.stack}  | File Name: ${fileName}, Line Number: ${lineNumber} `,
      CurrentURL: window.location.href,
      TargetSite: url,
      Source: `${error?.source || 'Unknown'}  | ${requestContext}`,
      IPAddress: getStoredValue("cachedIP") || 'Unknown',
      Browser: getBrowserType(),
      FacilityCode: storedLoginDetails?.FacilityCode,
      KioskCode: storedLoginDetails?.KiosksCode,
      MacAddress: storedLoginDetails?.KiosksMacAddress,
      PageInfo: `${error?.source || 'Unknown'}  | ${requestContext}`
    };
    // Send error to the logging API (adjust the URL as needed)
    await fetch(`${process.env.REACT_APP_API_URL}/ErrorLog/logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: "Logs/KioskAppErrLog",
        errorLog: JSON.stringify(errorLog)
      })
    }).then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Network response was not ok');
      }
    });
  }
  catch (e) {
    const msg = e?.message || "";
    // Safari Refresh issue 
    if (msg == "Cannot parse given Error object") return;

    // localStorage.setItem("ErrorMessage", msg);

    history.navigate("/Error");
  }
}

// helper functions

function authHeader(url) {
  // return auth header with jwt if user is logged in and request is to the api url
  const token = authToken();
  const isLoggedIn = !!token;
  const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
  if (isLoggedIn && isApiUrl) {
    return { authorization: token };
  } else {
    return {};
  }
}

function authToken() {
  return store.getState().auth.user?.Token;
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if ([401, 403].includes(response.status) && authToken()) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        const logout = () => store.dispatch(authActions.logout());
        logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
